module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('img', {
    staticClass: "img1",
    attrs: {
      "src": "static/img/base/weather-icon.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.change(1)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img2",
    attrs: {
      "src": "static/img/base/monitor-icon.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.change(0)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img3",
    attrs: {
      "src": "static/img/base/icon.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.change(3)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img4",
    attrs: {
      "src": "static/img/base/icon0.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.change(2)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74555536!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/sign/index.vue
// module id = 2040
// module chunks = 2